module.exports = __webpack_public_path__ + "media/images/illustrations/mover_with_refrigerator-50457d5db4c682d60f6047c72eaa54c6.svg";